<script>
  import PrismicDom from "prismic-dom";
  import { linkResolver } from "./prismic.js";

  export let text;

  let className = "";

  export { className as class };
</script>

{#if text}
  <div class="prismic {className}">
    {@html PrismicDom.RichText.asHtml(text, linkResolver)}
  </div>
{/if}
